function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgStacks = function SvgStacks(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Stacks' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M12,0 L48,0 L48,26 L42.001,26 L42.001,31.999 L36,31.999 L36,38 L0,38 L0,12 L6.001,12 L6.001,5.999 L12,5.999 L12,0 Z M14.001,2 L14.001,5.999 L42.001,5.999 L42.001,23.999 L46,23.999 L46,2 L14.001,2 Z M8,8 L8,12 L36,12 L36,30 L40,30 L40,8 L8,8 Z M2,36 L34,36 L34,13.999 L2,13.999 L2,36 Z"
  }));
};

SvgStacks = pure(SvgStacks);
SvgStacks.displayName = 'SvgStacks';
export default SvgStacks;